<template>
    <div class="clock-detail">
        <transition v-if="isLoadingClock" name="fade" mode="out-in">
            <WaitingBlock></WaitingBlock>
        </transition>

        <transition v-else-if="currentClock != null" name="fade" mode="out-in">
            <div>
                <transition v-if="viewState.isLoadingClockBoxes" name="fade" mode="out-in">
                    <WaitingBlock></WaitingBlock>
                </transition>
                <transition
                        v-else-if="boxListResponse == null || boxListResponse.dataItem == null || boxListResponse.dataItem.length === 0"
                        name="fade" mode="out-in" style="">
                    <div v-on:drop="drop" v-on:dragover="dragOver" id="placeholder__drag--zone" >
                        <ErrorPage ref="noCardList">
                            <template slot="Title">
                                No Box Scheduled In The Clock
                            </template>
                            <template slot="SubTitle">
                            </template>
                            <template slot="Content" >
                                Add or Drag &amp; drop a box on this placeholder!
                            </template>
                            <template slot="Actions">
                                &nbsp;
                            </template>
                        </ErrorPage>
                    </div>
                </transition>
                <transition v-else name="fade" mode="out-in">
                    <b-list-group class="list-cards" style="position: relative;" ref="cardList" v-on:drop="drop" v-on:dragover="dragOver">
                        <!-- v-else -->
                        <ItemListCard
                            v-for="(box, $index) in orderedBoxes"
                            :key="box.recorduid"
                            :item="box"
                            v-if="!box.deleted"
                            :is-draggable="openedBoxesUids.length === 0"
                            :noDate="true"
                            :open="openedBoxesUids.includes(box.scheduledData.uid)"
                            @toggle="(value) => handleBoxToggle(box, value)"
                            :sync-drop-down="true"
                            class="list-card-drag-target">
                            <template slot="Decorator">
                                <span class="grab handler"></span>
                                <!-- <span class="decorator" :disabled="box.scheduledData.position <= 1">
                                    <a href="#" @click.prevent="moveBox(box.scheduledData.uid, $index)"><i class="fas fa-arrow-up"></i></a>
                                </span>
                                <span class="decorator" :disabled="box.scheduledData.position >= orderedBoxes.length">
                                    <a href="#" @click.prevent="moveBox(box.scheduledData.uid, $index + 2)"><i class="fas fa-arrow-down"></i></a>
                                </span> -->
                            </template>
                            <template slot="QuickStats">
                                <span></span>
                            </template>
                            <template slot="Menu">
                              <a v-show="!box.editing" href="#" @click.prevent="duplicateBox(box)"><i class="fas fa-copy"></i></a>
                              <a v-show="!box.editing" href="#" @click.prevent="deleteBox(box)"><i class="fas fa-trash"></i></a>
                            </template>
                            <template slot="DropDown">
                                <div>
                                    <Filters
                                        type="clockBoxes"
                                        toggleLabel="Update"
                                        :addDefault="false"
                                        :disableBoxesSelection="true"
                                        :disableStationsSelection="true"
                                        :filters="box.trackFilters"
                                        :sortable="true"
                                        :with-requirements="true"
                                        @save="(filters) => handleSaveBoxFilters(box, filters)"
                                    />
                                </div>
                            </template>
                        </ItemListCard>
                    </b-list-group>
                </transition>

                <ClockRemovalCard ref="modalRemoval" v-show="viewState.showDeleteConfirmation"
                                  v-on:clockDeleted="clockDeleted" :stationUid="stationUid" :clock="currentClock"/>
            </div>
        </transition>
    </div>
</template>

<script>
    import store from '@/store/index.js';
    import WaitingBlock from '@/components/common/WaitingBlock.vue';
    import ItemListCard from '@/components/common/PlannerItemListCard.vue';
    import Translations from '@/store/translations';
    import {mapState, mapMutations, mapActions} from 'vuex';
    import ErrorPage from '@/components/common/ErrorPage';
    import EventBus from '@/eventbus';
    import Apis from '@/apis/index';
    import {HTTP} from "@/utils/http";
    import DropDownMenu from '@/components/common/DropDownMenu.vue';
    import ClockRemovalCard from './ClockRemovalCard.vue';
    import Filters from '@/components/common/Filters.vue'

    export default {
        name: "ClockDetails",
        store,
        components: {WaitingBlock, ItemListCard, ErrorPage, DropDownMenu, ClockRemovalCard, Filters},
        beforeMount() {

        },
        mounted() {
            EventBus.$on('AddBoxToClock', this.addBox);
            EventBus.$on("onClockRemove", this.removeClock);

            EventBus.$on('drag', this.drag);
            EventBus.$on('dragStart', this.dragStart);
            EventBus.$on('dragEnd', this.dragEnd);

            this.stationUid = this.$route.params.stationUid;
            this.clockUid = this.$route.params.clockUid;
            this.loadClock();
            this.loadClockBoxList();
        },
        beforeDestroy () {
            EventBus.$off('drag', this.drag);
            EventBus.$off('dragStart', this.dragStart);
            EventBus.$off('dragEnd', this.dragEnd);
        },
        watch: {
            '$route': function (to, from) {
                this.stationUid = this.$route.params.stationUid;
                this.clockUid = this.$route.params.clockUid;
                this.loadClock();
                this.loadClockBoxList();
            },
        },
        computed: {
            Translations: () => Translations,
            ...mapState({
                isLoadingClock: state => state.loadingStates.isLoadingClock,
                currentClock: state => state.currentClock,
                currentStationUid: state => state.currentStationUid
            }),
            orderedBoxes() {
                if (this.boxListResponse == null || this.boxListResponse.dataItem == null) return [];
                var array = this.boxListResponse.dataItem.sort((a, b) => a.scheduledData.position - b.scheduledData.position);
                return array;

            }
        },
        data() {
            return {
                viewState: {
                    isUpdatingList: false,
                    isLoadingClockBoxes: true,
                    showDeleteConfirmation: false
                },
                boxListResponse: null,
                stationUid: null,
                clockUid: null,
                isDragging: false,
                lineIndex: null,
                $items: null,
                $prevItem: null,
                currentDrag: null,
                openedBoxesUids: []
            }
        },
        methods: {
            async addBox(boxUid, position = 0) {
                // console.log("Add Box :", Apis.clocks.linkBox, { stationUid: this.stationUid, clockUid: this.clockUid, boxUid: boxUid });
                this.viewState.updatingList = true;
                try {
                    HTTP.post(Apis.clocks.linkBox, {
                        stationUid: this.stationUid,
                        clockUid: this.clockUid,
                        boxUid: boxUid,
                        position
                    })
                        .then(this.onBoxListUpdated)
                        .catch(this.onBoxListUpdateError)
                        .then(() => this.viewState.updatingList = false)
                } catch (e) {
                    alert(e);
                } finally {
                    this.viewState.updatingList = false;
                }
            },
            async moveBox(recordUid, position) {
                // console.log("Move :" , recordUid, position)
                this.viewState.updatingList = true;
                try {
                    HTTP.post(Apis.clocks.moveBox, {
                        stationUid: this.stationUid,
                        clockUid: this.clockUid,
                        recordUid: recordUid,
                        position: position
                    })
                        .then(this.onBoxListUpdated)
                        .catch(this.onBoxListUpdateError)
                        .then(() => this.viewState.updatingList = false)
                } catch (e) {
                    alert(e);
                } finally {
                    this.viewState.updatingList = false;
                }
            },
            async deleteBox(box) {
                box.editing = true;
                this.viewState.updatingList = true;
                try {
                    HTTP.post(Apis.clocks.unlinkBox, {
                        stationUid: this.stationUid,
                        clockUid: this.clockUid,
                        recordUid: box.scheduledData.uid
                    })
                        .then(this.onBoxListUpdated)
                        .catch(this.onBoxListUpdateError)
                        .then(() => this.viewState.updatingList = false)
                } catch (e) {
                    alert(e);
                } finally {
                    this.viewState.updatingList = false;
                }
            },
          async duplicateBox(box) {
            box.editing = true;
            this.viewState.updatingList = true;
            try {
              HTTP.post(Apis.clocks.linkBox, {
                stationUid: this.stationUid,
                clockUid: this.clockUid,
                boxUid: box.uid,
                position: box.scheduledData.position + 1
              }).then(this.onBoxListUpdated)
                  .catch(this.onBoxListUpdateError)
                  .then(() => this.viewState.updatingList = false)
                  .then((response) => {
                    this.duplicateFilter(box.scheduledData.position + 1 ,box.trackFilters)
                  })
            } catch (e) {
              alert(e);
            } finally {
              this.viewState.updatingList = false;
            }
          },

            onBoxListUpdated(response) {
                this.boxListResponse = response.data;
            },
            onBoxListUpdateError(error) {
                alert(error);
                this.boxListResponse = error.response.data;
            },
            duplicateFilter(position , filter){
              for (let i = 0; i < this.boxListResponse.dataItem.length; i++) {
                if(this.boxListResponse.dataItem[i].scheduledData.position === position){
                  this.handleSaveBoxFilters (this.boxListResponse.dataItem[i], filter , false)
                }
              }

            },
            loadClock: function () {
                this.boxListResponse = null;
                if (this.$route.params != null && this.$route.params.stationUid != null && this.$route.params.clockUid != null) {
                    store.dispatch("loadClock", this.$route.params);
                }
            },
            /* Clock Box List Load Events */
            loadClockBoxList() {
                this.viewState.isLoadingClockBoxes = true;
                HTTP.get(Apis.clocks.boxList, {params: {stationUid: this.stationUid, clockUid: this.clockUid}})
                    .then(this.onClockBoxListLoadComplete)
                    .catch(this.onClockBoxListLoadError)
                    .then(() => {
                        this.viewState.isLoadingClockBoxes = false;
                    });
            },
            onClockBoxListLoadComplete: function (response) {
                this.boxListResponse = response.data;
            },
            onClockBoxListLoadError: function (error) {
                this.boxListResponse = error.response.data;
            },
            clockDeleted() {
                this.$store.dispatch('loadStationClocks', this.$store.state.currentStationUid);
                this.$router.push({name: 'ClocksHome', params: {stationUid: this.stationUid}});
            },
            removeClock() {
                this.viewState.showDeleteConfirmation = true;
                this.$refs.modalRemoval.show();
            },
            drag(e) {
                if (!this.isDragging) {
                    this.setDomData(e);
                }
                if (!this.orderedBoxes || this.orderedBoxes.length === 0) {
                    return;
                }

                // Position of cursor in list
                const listContainer = this.$refs.cardList;
                const rect = listContainer.getBoundingClientRect();
                const mouseX = e.clientX - rect.left;
                const mouseY = e.clientY - rect.top;
               
                if (mouseX < 0 || mouseX > rect.width || mouseY < 0 || mouseY > listContainer.scrollHeight) {
                    this.isDragging = true;
                    this.removeLineIndex();
                    return;
                }

                // Select item that prec the current item regarding mouseY
                const $prevItem = this.getPrev(mouseY);
                // console.log(mouseY, $prevItem, $prevItem.toggleY);

                if ($prevItem !== this.$prevItem) {
                    this.$prevItem = $prevItem;
                    // console.log('update line :', this.$prevItem);
                    this.updateLineIndex();
                }

                this.isDragging = true;
            },
            dragOver(e) {
                // Fix for drop to launch
                e.preventDefault();
            },
            dragStart(e, item) {
                this.currentDrag = item;
            },
            dragEnd(e, item) {
                this.removeLineIndex();
                this.isDragging = false;
            },
            drop(e) {
                e.preventDefault();
                if (!this.currentDrag) {
                    return;
                }

                const {uid} = this.currentDrag;

                // No box already
                if (!this.orderedBoxes || this.orderedBoxes.length === 0) {
                    this.addBox(uid, 1);
                    return;
                }

                const index = this.$prevItem === 'first' ? 1 : [...this.$items].indexOf(this.$prevItem) + 2;

                // Move box
                if (this.currentDrag.scheduledData) {
                    this.moveBox(this.currentDrag.scheduledData.uid, index);
                    return;
                }

                // Add box
                this.addBox(uid, index);
            },
            updateLineIndex() {
                this.removeLineIndex();

                this.lineIndex = document.createElement('span');
                this.lineIndex.classList.add('line-index');

                if (this.$prevItem === 'first') {
                    this.$refs.cardList.insertBefore(this.lineIndex, this.$items[0]);
                } else {
                    this.$refs.cardList.insertBefore(this.lineIndex, this.$prevItem.nextSibling);
                }
            },
            removeLineIndex() {
                if (this.lineIndex) {
                    this.lineIndex.parentElement.removeChild(this.lineIndex);
                    this.lineIndex = null;
                }
            },
            setDomData(e) {
                if (this.$refs.cardList) {
                    this.$items = [...this.$refs.cardList.querySelectorAll('.list-card-drag-target[draggable]:not(.is-dragged)')];

                    for (let i = 0; i < this.$items.length; i++) {
                        const $item = this.$items[i];
                        const {offsetTop} = $item;
                        $item.toggleY = offsetTop + ($item.offsetHeight / 2);
                    }

                }

            },
            getPrev(mouseY) {
                const $prevItems = this.$items.filter((item) => {
                    return item.toggleY < mouseY;
                });

                return $prevItems.length === 0 ? 'first' : $prevItems[$prevItems.length - 1];
            },
            handleBoxToggle (box, value) {
                if (this.openedBoxesUids.includes(box.scheduledData.uid)) {
                    this.openedBoxesUids = this.openedBoxesUids.filter(uid => uid !== box.scheduledData.uid)
                } else {
                    this.openedBoxesUids.push(box.scheduledData.uid)
                }
            },
            handleSaveBoxFilters (box, filters, isToaster = true) {
                console.log(box, filters)
                this.viewState.updatingList = true;

                try {
                    HTTP.post(Apis.clocks.updateBoxFilters, {
                        stationUid: this.stationUid,
                        clockUid: this.clockUid,
                        recordUid: box.scheduledData.uid,
                        filters: filters.map((filter, index) => {
                                return {
                                    ...filter,
                                    position: index
                                }
                            })
                    })
                        .then((response) => {
                            if(response.data.isSuccess && isToaster){
                                this.$store.dispatch('Toasts/addToast', {
                                    title: 'Success',
                                    message: 'Filters successfully updated',
                                    delay: 1500,
                                    type: 'success'
                                });
                            }
                            // Update box filters in the local state
                            this.boxListResponse.dataItem.forEach((item, index) => {
                                if (item.scheduledData.uid === box.scheduledData.uid) {
                                    this.boxListResponse.dataItem[index].trackFilters = filters
                                }
                            })
                        })
                        .catch((error) => {
                            console.log({ error })
                        })
                } catch (e) {
                    alert(e);
                } finally {
                    this.viewState.updatingList = false;
                }
            }
        }
    }

</script>

<style lang="scss" scoped>
    .list-cards {
        position: relative;
        min-height: 50px;
        height: 100vh;
        .draggable {
            width: 100% !important;
            height: auto !important;
            background-color: transparent !important;
            &.active {
                background: transparent;
                margin-bottom: 15px;
                border: 2px solid black;
            }
            i.handler {
                cursor: grab;
            }
        }
    }

    .list-card {    
        padding-top: 0;
        padding-left: 0;
        padding-bottom: 0;

        .name {
            margin-left: 0;
            margin-bottom: 0;
        }

        .stat-creation {
            font-size: 12px;
            color: #8f8f8f;
        }

        .grab {
            flex-shrink: 0;
            position: relative;
            margin-left: 0;
            background: transparent;

            a {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;

                i {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }
            }

            &.handler {
                width: 44px;
                height: 36px;
                background-color: transparent;
                cursor: grab;

                &::before,
                &::after {
                    content: '';
                    position: absolute;
                    top: 50%;
                    left: 17px;
                    width: 10px;
                    height: 1px;
                    transform: translateY(-2px);
                    background-color: rgba(41, 44, 51, .5);
                }

                &::after {
                    transform: translateY(1px);
                }
            }
        }

        &.is-dragged {
            .grab.handler {
                cursor: grabbing;
            }
        }
    }
    .placeholder-drag-over {
        border: 1px dashed #bfbfbf;
    }

    .placeholder__drag--zone-active {
        border: 1px dashed #bfbfbf;
        opacity: 0.7;
    }

</style>
